import type {
  EmailMessageDeliveryStatus,
  EmailMessageMetadata,
  EmailMessageSource,
  MessageData,
} from '@fluenceur/types';

export interface EmailMetadataView extends Partial<EmailMessageMetadata> {
  source?: EmailMessageSource;
  flowName?: string | null;
  flowExecutionId?: string;
  lastResendEventAt?: string;
  deliveryStatus?: EmailMessageDeliveryStatus;
}

/**
 * Safely extract email metadata from a MessageData object.
 */
export function getEmailMetadata(
  message: Pick<MessageData, 'metadata'> | null | undefined
): EmailMetadataView | undefined {
  if (!message?.metadata) return undefined;
  return message.metadata as EmailMetadataView;
}
